var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMainBottom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 100,
    viewBox: "0 0 350 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.6753H350V99.1454H85.4701C38.2663 99.1454 0 60.8791 0 13.6753V13.6753Z",
    fill: "url(#paint0_linear_850_37360)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7383 99.9837L350 70.0791V99.9837H91.7383Z",
    fill: "var(--advisor-profile-page-color1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 55.5L350 99.987C259.221 99.987 150.96 99.9927 88.4807 99.9966C56.5633 99.9986 27.1015 83.0584 11 55.5V55.5Z",
    fill: "url(#paint1_linear_850_37360)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_850_37360",
    x1: 127.5,
    y1: -0.287642,
    x2: 127.775,
    y2: 99.1457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--advisor-profile-page-color1)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--advisor-profile-page-color1)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_850_37360",
    x1: -0.000176368,
    y1: 0.445746,
    x2: 337.073,
    y2: 132.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--advisor-profile-page-color2)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989583,
    stopColor: "var(--advisor-profile-page-main-color)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainBottom);
export default __webpack_public_path__ + "static/media/main_bottom.7ea17ab7d45ee0b131eb79d606acf60f.svg";
export { ForwardRef as ReactComponent };